import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getCountyByGeoID } from "../features/countySlice"
import { getMuniByMunCode, setMuni } from "../features/muniSlice"

//** This is a hook to set the location state based on incoming search params */
const useLocSync = (locType, locId) => {

  // console.log('syncing location', locId, locType)
  
  const dispatch = useDispatch()
  const county = useSelector(state => state.county)
  const muni = useSelector(state => state.muni)
  
  // Only extract the IDs we need for comparison to avoid triggering on every object update
  const countyId = county?.id
  const muniCode = muni?.MUN_CODE
  
  console.log('locType', locType)
  
  useEffect(() => {
    if (locType === 'county') {
      console.log('syncing county', locId, countyId)
      if (locId !== countyId) {
        dispatch(getCountyByGeoID(locId))
        dispatch(setMuni(null))
      }
    } else if (locType === 'muni') {
      if (locId !== muniCode) {
        dispatch(getMuniByMunCode(locId))
      }
    }
  }, [locType, locId, dispatch, countyId, muniCode])
  
  return
}

export default useLocSync